var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyOverview1 = function SvgCompanyOverview1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 313 313"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 313,
    height: 313,
    fill: "url(#CompanyOverview1_svg__a)",
    rx: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CompanyOverview1_svg__b)",
    d: "M193.34 82.251c-1.118 0-2.147.61-2.683 1.592l-17.411 31.88-20.104 36.811c-1.159 2.123-4.207 2.123-5.366 0l-20.104-36.811-17.411-31.88a3.06 3.06 0 0 0-2.683-1.592H55.295c-2.353 0-3.824 2.547-2.648 4.585l47.912 82.985 47.912 82.985c1.177 2.038 4.118 2.038 5.295 0l47.91-82.985 47.912-82.985c1.176-2.037-.294-4.585-2.648-4.585z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CompanyOverview1_svg__c)",
    d: "M193.34 82.251c-1.118 0-2.147.61-2.683 1.592l-17.411 31.882-20.104 36.811c-1.159 2.122-4.207 2.122-5.366 0l-20.104-36.811-17.411-31.882a3.06 3.06 0 0 0-2.683-1.592H55.295c-2.353 0-3.824 2.547-2.647 4.585l1.51 2.616c9.751 12.775 24.216 32.417 39.072 53.16l14.66 20.47c23.776 33.199 62.683 33.199 86.459 0l14.66-20.47c12.963-18.103 26.103-35.576 36.356-48.521a3 3 0 0 0 .25-.369l3.976-6.885c1.177-2.038-.294-4.586-2.647-4.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CompanyOverview1_svg__d)",
    d: "M153.251 142.034c-1.159 2.122-4.206 2.122-5.366 0l-17.851-32.686-18.065-33.075c-1.112-2.037.362-4.522 2.683-4.522h71.831c2.321 0 3.795 2.485 2.683 4.522l-18.065 33.075z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CompanyOverview1_svg__e)",
    d: "M114.246 73.068c-1.484 0-2.097 1.904-.891 2.77L127.29 85.85c13.909 9.994 32.646 9.994 46.555 0l13.936-10.012c1.205-.866.593-2.77-.892-2.77h-72.643"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanyOverview1_svg__a",
    x1: 442.371,
    x2: -44.417,
    y1: 94.713,
    y2: 245.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanyOverview1_svg__b",
    x1: 151.118,
    x2: 151.118,
    y1: 82.251,
    y2: 257.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanyOverview1_svg__c",
    x1: 151.194,
    x2: 151.194,
    y1: 40.083,
    y2: 171.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanyOverview1_svg__d",
    x1: 150.625,
    x2: 150.568,
    y1: 17.058,
    y2: 146.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanyOverview1_svg__e",
    x1: 150.625,
    x2: 150.568,
    y1: 51.349,
    y2: 93.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })))));
};
export default SvgCompanyOverview1;